import React from "react";
import OptionList from "../OptionList";

/**
 * `choice` (and a `select` with `multiple`) — radios or checkboxes under the field's label as the
 * group legend; `allowOther` reveals a free-text input whose text is the submitted value (D-W15).
 */
export default function ChoiceField({ id, field, value, other, error, onChange, onOtherChange, onBlur, msg }) {
	return (
		<OptionList
			id={id}
			legend={field.label}
			subtitle={field.hint}
			options={field.options}
			multiple={field.multiple === true}
			allowOther={field.allowOther === true}
			value={value}
			other={other}
			onChange={onChange}
			onOtherChange={onOtherChange}
			error={error}
			required={field.required === true}
			onBlur={onBlur}
			msg={msg}
		/>
	);
}
